import React from 'react';
import { RenderElementProps } from 'slate-react';
import MentionElement from './components/MentionElement';
import LinkElement from './components/LinkElement';
import { ELEMENT_TYPES } from 'components/RichTextEditorField/constants';

type EditorElementProps = RenderElementProps;

const EditorElement: React.FC<EditorElementProps> = (props) => {
  const { children, attributes, element } = props;

  switch (element.type) {
    case ELEMENT_TYPES.LINK:
      return (
        <LinkElement href={element.href} {...attributes}>
          {children}
        </LinkElement>
      );

    case ELEMENT_TYPES.MENTION:
      return (
        <MentionElement character={element.character} {...attributes}>
          {children}
        </MentionElement>
      );

    case ELEMENT_TYPES.ORDERED_LIST:
      return <ol {...attributes}>{children}</ol>;

    case ELEMENT_TYPES.UNORDERED_LIST:
      return <ul {...attributes}>{children}</ul>;

    case ELEMENT_TYPES.LIST_ITEM:
      return <li {...attributes}>{children}</li>;

    case ELEMENT_TYPES.PARAGRAPH:
      return <p {...attributes}>{children}</p>;

    case ELEMENT_TYPES.INDENT:
      return <span {...attributes}>&emsp;{children}</span>;

    default:
      return <div {...attributes}>{children}</div>;
  }
};

export default EditorElement;
